import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import InstitutionMetricsService from "../../Services/InstitutionMetrics.service";
import StudentMetricsChartWidget from "../Presentational/Widgets/StudentMetricsChartWidget";
import useService from "../Hooks/useService";
const StudentMetricsChartContainer = (props) => {
    const [metricsState, loadMetrics] = useService(InstitutionMetricsService.getMetrics);
    React.useEffect(() => {
        loadMetrics();
    }, [loadMetrics]);
    return (_jsx(StudentMetricsChartWidget, { chartState: metricsState, refresh: () => {
            loadMetrics();
        }, type: props.type }));
};
export default StudentMetricsChartContainer;
